<template>
  <v-layout>
    <v-flex xs3 sm3>
      <v-container fluid>
        <v-card class="grey lighten-3">
          <v-card-title class="headline primary white--text">
            Questions List
          </v-card-title>
          <v-card-text>
            <v-layout class="previous d-block">
              <v-list class="d-block scrollable">
                <v-list-tile
                  avatar
                  v-for="(item, i) in indexData"
                  :key="i"
                  @click="
                    getComponent(item.project_id, item.id, item.ui_category_id)
                  "
                  :class="getClass(item.id)"
                >
                  <v-list-tile-avatar>
                    <v-icon medium color="#11111">list</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content v-if="item.project_language == 2">
                    <v-list-tile-title :title="item.question_bangla">
                      {{ item.question_bangla }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content v-else>
                    <v-list-tile-title :title="item.question">
                      {{ item.question }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-flex>
    <v-flex xs9 sm9>
      <v-container fluid>
        <v-card class="grey lighten-3">
          <v-card-title class="headline primary white--text">
            <span>Response Summary Report</span>
            <v-spacer></v-spacer>
            <v-btn small color="success" @click="back">Back</v-btn>
          </v-card-title>
          <v-card-text>
            <h2 class="text-xs-right">N = {{ totalCount }}</h2>
            <v-layout class="previous d-block">
              <!-- {{ ui_category_id }} -->

              <FreqTblPieBar
                :dataset.sync="dataSet"
                v-if="
                  ui_category_id == 1 ||
                  ui_category_id == 2 ||
                  ui_category_id == 4 ||
                  ui_category_id == 14
                "
              />
              <WordCloud
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 5"
              />
              <ScatterPlot
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 6"
              />
              <Boxplot
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 7"
              />
              <BarGraph
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 12"
              />
              <LocationGraph
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 13"
              />
              <Histogram
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 18"
              />
              <StarRating
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 8"
              />
              <ImageQues
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 9"
              />
              <AudioQues
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 10"
              />
              <VideoQues
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 11"
              />
              <NodataComponent v-else />
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script ln="ts">
import axios from "axios";
// import { mapGetters } from "vuex";
// import router from "../../../router";
import { ROOT_URL } from "@/api/connectingUrls";
import FreqTblPieBar from "../Reports/DasherResponseReports/FrequencyTablewithPieBar.vue";
import ScatterPlot from "../Reports/DasherResponseReports/RangeScatterPlotGraph.vue";
import Boxplot from "../Reports/DasherResponseReports/SliderBoxplotGraph.vue";
import LocationGraph from "../Reports/DasherResponseReports/LocationGraph.vue";
import Histogram from "../Reports/DasherResponseReports/Histogram.vue";
import StarRating from "../Reports/DasherResponseReports/StarRating.vue";
import WordCloud from "../Reports/DasherResponseReports/WordCloudOpenended.vue";
import ImageQues from "../Reports/DasherResponseReports/ImageResponseReport.vue";
import AudioQues from "../Reports/DasherResponseReports/AudioResponseReport.vue";
import VideoQues from "../Reports/DasherResponseReports/VideoResponseReport.vue";
import NodataComponent from "../Reports/DasherResponseReports/NodataComponent.vue";
import BarGraph from "../Reports/DasherResponseReports/BarGraph.vue";

export default {
  components: {
    FreqTblPieBar,
    ScatterPlot,
    Boxplot,
    LocationGraph,
    Histogram,
    StarRating,
    NodataComponent,
    WordCloud,
    ImageQues,
    AudioQues,
    VideoQues,
    BarGraph,
  },
  data: () => ({
    question_id: null,
    ui_category_id: null,
    indexData: [],
    dataSet: [{}],
    totalCount: 0,
    activeQuesId: 0,
  }),

  computed: {
    // ...mapGetters(["indexData", "error", "statusCode", "errorMsg"]),
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.ui_category_id = null;
      try {
        const token = window.localStorage.getItem("datadash_token");
        if (token != null) {
          return axios
            .get(`${ROOT_URL}/get-project-question/${this.$route.params.id}`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              if (response.status == 200) {
                this.indexData = response.data.data;
              }
            });
        }
      } catch (error) {
        // console.log(error);
      }
    },
    async getComponent(projectId, quesId, queTypeId) {
      this.activeQuesId = quesId;
      let postData = {
        project_id: projectId,
        question_id: quesId,
        ui_category_id: queTypeId,
      };
      try {
        const token = window.localStorage.getItem("datadash_token");
        if (token != null) {
          return axios
            .post(`${ROOT_URL}/${"response-report"}`, postData, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              if (response.data.statusCode == 200) {
                this.ui_category_id = queTypeId;
                this.dataSet = response.data.data;
                this.totalCount = this.dataSet.totalRes
                  ? this.dataSet.totalRes
                  : this.dataSet.datas && this.dataSet.datas.length
                  ? this.dataSet.datas.reduce((acc, cur) => acc + cur.count, 0)
                  : 0;
              }
            });
        }
      } catch (error) {
        // console.log(error);
      }
    },
    back() {
      this.$router.push(`/project/${this.$route.params.id}/preview`);
    },
    getClass(quesId) {
      if (quesId == this.activeQuesId) {
        return "active-question";
      }
    },
  },
};
</script>
<style scoped>
.scrollable {
  height: 500px; /* or any height you want */
  overflow-y: auto;
}
.active-question {
  background-color: #e4e4e4;
}
</style>
